// overlay-style.ts — makes the SDK's own system overlay visible (SC-61815). The SDK paints it as an UNSTYLED
// <div data-overlay-kind="…"> appended to <body>: under Dice's full-viewport game it rendered nowhere a player could
// see, so an operator block (ui.blocked: a reality check, the cashier, maintenance) left the board apparently live.
//   - blocked / lostConnection: a full-viewport cover above the game and the SDK boot loader (z 2147483000), below Dice's
//     own block panel (boot.ts, z 2147483647). Its text is the SDK's catalog copy, never the operator's reason.
//   - fatal: hidden. Dice renders its own fatal notice (fatal-notice.ts) with the actionable copy; two would stack.
// Injected as a <style> element (style-src allows inline styles on both the page and the gw shell); the shell bundle is
// one JS file, so a CSS import (a separate file) is not an option there.
const OVERLAY_Z = 2147483100;

export const OVERLAY_CSS =
  `[data-overlay-kind]{position:fixed;inset:0;z-index:${OVERLAY_Z};display:flex;flex-direction:column;gap:12px;` +
  "align-items:center;justify-content:center;padding:32px;text-align:center;text-wrap:balance;" +
  "background:rgba(1,13,6,.94);color:#e8eef7;font:16px/1.5 var(--ui,system-ui,sans-serif)}" +
  '[data-overlay-kind] [data-overlay-part="title"]{font-size:20px;font-weight:600}' +
  '[data-overlay-kind] [data-overlay-part="body"]{max-width:44ch;color:#aab6c8}' +
  '[data-overlay-kind="fatal"]{display:none}';

/** Installs the overlay style once per document. */
export function installOverlayStyle(doc: Document): void {
  if (doc.querySelector("style[data-dice-overlay]")) return;
  const style = doc.createElement("style");
  style.setAttribute("data-dice-overlay", "");
  style.textContent = OVERLAY_CSS;
  doc.head.appendChild(style);
}
